import type { SVGProps } from "react";
export interface DumbellIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DumbellIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DumbellIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.04 15.369a1.126 1.126 0 0 1 1.59 1.59l-1.293 1.296a.715.715 0 0 0 0 1.01l1.397 1.398a.716.716 0 0 0 1.012 0l1.294-1.294a1.125 1.125 0 0 1 1.59 1.591l-1.293 1.295a2.967 2.967 0 0 1-3.968.204l-.226-.204-1.397-1.399a2.964 2.964 0 0 1 0-4.192zM15.202 10.2a1.126 1.126 0 0 1 1.591 1.592l-5 5.001-.087.078a1.126 1.126 0 0 1-1.506-1.669zm-3.001-3a1.125 1.125 0 0 1 1.59 1.59l-5 5.002a1.125 1.125 0 1 1-1.591-1.59l5-5.001Zm4.687-5.659a2.964 2.964 0 0 1 3.967.204l1.4 1.397.203.226a2.967 2.967 0 0 1-.204 3.968L20.96 8.63a1.125 1.125 0 1 1-1.59-1.59l1.293-1.294.092-.113a.72.72 0 0 0 0-.786l-.092-.113-1.398-1.397a.716.716 0 0 0-.9-.093l-.11.093L16.96 4.63a1.125 1.125 0 0 1-1.591-1.59l1.295-1.294.225-.204Z"
      />
      <path
        fill={color}
        d="M3.38 10.758a3.127 3.127 0 0 1 4.184.216l5.468 5.468a3.127 3.127 0 0 1 .215 4.184l-.215.237-.835.835a3.125 3.125 0 0 1-4.42 0l-5.47-5.47a3.125 3.125 0 0 1 0-4.42l.836-.836zm2.591 1.807a.875.875 0 0 0-1.1-.113l-.138.113-.835.835a.875.875 0 0 0 0 1.237l5.47 5.47a.876.876 0 0 0 1.238 0l.835-.835.113-.138a.88.88 0 0 0-.113-1.101l-5.47-5.469Zm6.075-10.473a3.126 3.126 0 0 1 4.182.216l5.47 5.47.215.237a3.13 3.13 0 0 1 0 3.944l-.215.238-.835.835a3.126 3.126 0 0 1-4.421 0l-5.468-5.468a3.126 3.126 0 0 1 0-4.421l.835-.835zM14.637 3.9a.876.876 0 0 0-1.1-.113l-.138.113-.834.834a.875.875 0 0 0 0 1.238l5.47 5.47.136.113a.88.88 0 0 0 1.101-.113l.835-.835.113-.138a.876.876 0 0 0-.113-1.1z"
      />
    </svg>
  );
}
